import { useQuery } from '@tanstack/react-query';
import { NextSessionsInput, nextSessions } from '@uplift/api';
import { BaseQueryOpts } from '../baseTypes';


export const usePatientNextAppointmentsQuery = (params: NextSessionsInput, opts?: BaseQueryOpts) => {
  return useQuery([ 'next-sessions', params ], async () => {
    const response = await nextSessions(params);

    return response.data;
  }, opts);
};
